<template>
  <v-dialog 
  :value="value" 
  max-width="720"
  @input="$emit('input')">
    <v-card class="pb-2">
      <v-card-title>
        <span class="headline">Lookalikes - @{{handle}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="10"
              :no-data-text="'Empty list'"
              class="elevation-1"              
              :key="dataTableKey"
            >
              <template v-slot:[`item.handle`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    <!-- <v-avatar :size="avatarSize" color="grey lighten-4">
                      <img v-bind:src="item.picture" alt="avatar" />
                    </v-avatar>
                    <a
                      target="_blank"
                      v-bind:href="'https://instagram.com/' + item.username"
                    >@{{ item.username }}</a> -->
                    <v-avatar :size="avatarSize" color="grey lighten-4" style="margin:10px 0">
                      <img v-bind:src="item.picture" alt="avatar" />
                    </v-avatar>
                    <social-handle
                      divClassName="d-inline"
                      :isTikTok="platform === 'tiktok'"
                      :isInstagram="platform === 'instagram'"
                      :isYoutube="platform === 'youtube'"
                      :tiktokHandle="item.username"
                      :instagramHandle="item.username"
                      :youtubeHandle="item.custom_name"
                    />
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.countryName`]="{ item }">
                <tr>
                  <td class="text-xs-left" v-if="item.countryName">
                    {{item.countryName}}
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.followers`]="{ item }">
                <tr>
                  <td class="text-xs-left">
                    {{item.followers | thousandSeprator}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import SocialHandle from '@/components/scoped/custom/SocialHandle';
export default {
  name: 'CampaignListsModal',
  props: [
    'items',
    'value',
    'handle',
    'platform'
  ],
  components: {
    SocialHandle
  },
  data() {
    return {
      headers: [
        {
          text: 'Handle',
          value: 'handle'
        },
        {
          text: 'Country',
          value: 'countryName'
        },
        {
          text: 'Followers',
          value: 'followers'
        }
      ],
      dataTableKey: 1,
      avatarSize: 45 // avatar
    }
  },
  methods: {
    close() {
      this.$emit('input')
    }
  }
}
</script>



// WEBPACK FOOTER //
// SimilarUsersModal.vue?51c08e18